export const options_messageList_quick_showAsConversation = "VUd";
export const options_messageList_quick_showAsMessage = "WUd";
export const options_conversations_quick_messageView = "XUd";
export default {options_messageList_quick_showAsConversation,options_messageList_quick_showAsMessage,options_conversations_quick_messageView};